import _ from "lodash";
import {
    FETCH_USERS,
    UPDATE_USER
} from '../actions/types';

const usersReducer = (state = {}, action) => {
    switch (action.type) {
        case FETCH_USERS:
            return {...state, ..._.mapKeys(action.payload.users, 'id')};
        case UPDATE_USER:
            return {...state, [action.payload.user.id]: action.payload.user}
        default:
            return state;
    }
};

export default usersReducer